/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>驻镇代表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
          <el-form-item label="名称" >
            <el-input size="small" v-model="formProInfo.name" placeholder="输入名称"></el-input>
          </el-form-item>
		  
		  
    	  <el-form-item label="省份">
    	    <el-input size="small" v-model="formProInfo.province" placeholder="输入省份"></el-input>
    	  </el-form-item>
		  
		  <el-form-item label="城市">
		    <el-input size="small" v-model="formProInfo.city" placeholder="输入城市"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="县区">
		    <el-input size="small" v-model="formProInfo.county" placeholder="输入县区"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="手机号">
		    <el-input size="small" v-model="formProInfo.phoneNumber" placeholder="输入手机号"></el-input>
		  </el-form-item>
		  
         <!-- <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item>
          <el-form-item> -->
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" >搜索</el-button>
           
          </el-form-item>
        </el-form>
		 
		 <div class="block">
			 <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @change="choosebt">
			     <el-radio-button label="month" >月</el-radio-button>
			     <el-radio-button label="year">年</el-radio-button>
			     <el-radio-button label="date">日</el-radio-button>
			 </el-radio-group>
		     <el-date-picker
		       v-model="value2"
		       type="month"
		       placeholder="选择月" 
			   v-if="tabPosition=='month'"
			   @change="changemonth"
			   value-format="yyyy-MM">
		     </el-date-picker>
			 
			 <el-date-picker
			   v-model="value3"
			   type="year"
			   placeholder="选择年"
			   v-if="tabPosition=='year'"
			   @change="changeyear"
			   value-format="yyyy">
			 </el-date-picker>
			 
			  <el-date-picker
			   v-model="value1"
			   type="date"
			   placeholder="选择日期"
			   v-if="tabPosition=='date'"
			   @change="changedata"
			   value-format="yyyy-MM-dd">
			  </el-date-picker>
			     
		   </div>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="name" label="名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="phoneNumber" label="手机号" >
		  </el-table-column>
		  <el-table-column align="center" prop="area" label="地区" >
		  </el-table-column>
		  <el-table-column align="center" prop="totalScore" label="kpi考核总分" >
			  
		  </el-table-column>
		  <el-table-column align="center" label="拜访用户" >
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.visitUserDto.targetNum}}{{scope.row.visitUserDto.unit}}</div>
			  <div>完成:{{scope.row.visitUserDto.finishedNum}}{{scope.row.visitUserDto.unit}}</div>
			  <div>进度:{{scope.row.visitUserDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.visitUserDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.visitUserDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" label="准用户" >
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.potentialUserDto.targetNum}}{{scope.row.potentialUserDto.unit}}</div>
			  <div>完成:{{scope.row.potentialUserDto.finishedNum}}{{scope.row.potentialUserDto.unit}}</div>
			  <div>进度:{{scope.row.potentialUserDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.potentialUserDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.potentialUserDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" label="成交用户" >
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.transactionUserDto.targetNum}}{{scope.row.transactionUserDto.unit}}</div>
			  <div>完成:{{scope.row.transactionUserDto.finishedNum}}{{scope.row.transactionUserDto.unit}}</div>
			  <div>进度:{{scope.row.transactionUserDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.transactionUserDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.transactionUserDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" label="单叶发放" >
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.singlePageDto.targetNum}}{{scope.row.singlePageDto.unit}}</div>
			  <div>完成:{{scope.row.singlePageDto.finishedNum}}{{scope.row.singlePageDto.unit}}</div>
			  <div>进度:{{scope.row.singlePageDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.singlePageDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.singlePageDto.score}}分</div>
			  </template>
		  </el-table-column>
		  <el-table-column align="center" prop="posterPasteNum" label="海报黏贴" >
			  <template slot-scope="scope">
			  <div>目标:{{scope.row.posterPasteDto.targetNum}}{{scope.row.posterPasteDto.unit}}</div>
			  <div>完成:{{scope.row.posterPasteDto.finishedNum}}{{scope.row.posterPasteDto.unit}}</div>
			  <div>进度:{{scope.row.posterPasteDto.progressPercent}}%</div>
			  <div>权重:{{scope.row.posterPasteDto.weightPercent}}%</div>
			  <div>得分:{{scope.row.posterPasteDto.score}}分</div>
			  </template>
		  </el-table-column>
         
          <el-table-column  align="center"  label="操作" min-width="140">
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">详情</el-button>
			  <!-- <el-button size="mini" type="danger" @click="deleteProInfo(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
    import {
      queryPageKpiDataOfTown
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
         tabPosition: 'month',
		 value2:'',
		 value3:'',
		 value1:'',
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
           province:'',
		   city:'',
		   county:'',
		   phoneNumber:'',
		   year:'',
		   month:'',
		   date:''
			
          },
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
         const now = new Date()
		 this.value3 = String(now.getFullYear())
		this.value2 = this.getCurrentYearMonth()
		this.formProInfo.month = this.value2.substring(this.value2.length - 2)
		this.formProInfo.year = this.value3
		this.formProInfo.date = this.value1
		this.getData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  changedata(e){
			  this.formProInfo.date = this.value1
			  this.getData(this.formProInfo)
		  },
		  changeyear(e){
			  this.formProInfo.year = this.value3
			  this.getData(this.formProInfo)
		  },
		  changemonth(e){
			  console.log(999999,this.value2)
			  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
			  this.getData(this.formProInfo)
		  },
		  getCurrentYearMonth() {
		      const now = new Date();
		      const year = now.getFullYear();
		      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1，并确保是两位数
		      return `${year}-${month}`;
		  },
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/residentDataAdd?shuo=' + '新增' + '&category='+ this.formProInfo.category})
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/representTownDataAdd?id='+row.userId + '&aid=' + row.accountId + '&ph='+ row.phoneNumber + '&na='+ row.name + '&ar='+ row.area })
		   
		  },
		  choosebt(e){
			  console.log(1234567,e)
			  if(e=='month'){
				  this.value2 = this.getCurrentYearMonth()
				  this.value1 = ''
				  const now = new Date()
				  this.value3 = String(now.getFullYear())
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				  this.getData(this.formProInfo)
			  }else if(e=='year'){
				  this.value3 =  `${new Date().getFullYear()}`;
				  console.log(666666,this.value3)
				  this.value1 = ''
				  this.value2 = ''
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				   this.getData(this.formProInfo)
			  }else{
				  const dateObj = new Date();
				  const year = dateObj.getFullYear(); 
				  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
				  const day = String(dateObj.getDate()).padStart(2, "0");
				  const formattedDate = `${year}-${month}-${day}`;
				  this.value1 = formattedDate
				  this.value3 = ''
				  this.value2 = ''
				  this.formProInfo.month = this.value2.substring(this.value2.length - 2)
				  this.formProInfo.year = this.value3
				  this.formProInfo.date = this.value1
				   this.getData(this.formProInfo)
			  }
		  },
		  changetype(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
					 level:2,
					 category:3,
					 firstLevelId:this.formProInfo.firstLevelId,
					 secondLevelId:''
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.secondLevelId = null
				this.formProInfo.thirdLevelId = null
				this.typeList2 = res.data
				
				}
			  })
		  },
		  
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.updator=''
			this.formProInfo.active=''
			this.formProInfo.firstLevelId=''
			this.formProInfo.secondLevelId=''
			this.formProInfo.thirdLevelId=''
			this.formProInfo.downloadStatus=''
			this.formProInfo.shareStatus=''
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          queryPageKpiDataOfTown(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  item.visitUserNum = '完成：' + item.visitUserNum
				  item.potentialUserNum = '完成：' + item.potentialUserNum
				  item.transactionUserNum = '完成：' + item.transactionUserNum
				  item.singlePageNum = '完成：' + item.singlePageNum
				  item.posterPasteNum = '完成：' + item.posterPasteNum
			  })

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 80px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 63px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 0px;  
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  } 
  .user-search{
	  position: relative;
  }
  /deep/ .el-radio-button__inner{
	  width: 90px;
  }
  /deep/ .el-radio-button__inner{
	  padding: 8px 20px;
  }
  .block{
	  display: flex;
  }
  /deep/ .block .el-input__inner{
	  line-height: 32px;
	  height: 32px;
	  border: 0;
  }
  /deep/ .el-input__icon{
	  font-size: 20px;
	  height: 36px;
	  line-height: 32px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/assessment/representTownData.vue